const itemMovementType = {
  Adjustment: 'Adjustment',
  BulkPackaging: 'Bulk Packaging',
  CancelledReception: 'Cancelled reception',
  CancelledShipment: 'Cancelled shipment',
  ContainerTransfer: 'Container transfer',
  Merge: 'Merge',
  MissingItemResolution: 'Missing item resolution',
  Move: 'Move',
  OrderTransfer: 'Transfer',
  ReceptionByBarge: 'Reception by barge',
  ReceptionByContainer: 'Reception from container',
  ReceptionByOther: 'Reception by other',
  ReceptionByRailcar: 'Reception by railcar',
  ReceptionByTruck: 'Reception by truck',
  ReceptionByVessel: 'Reception by vessel',
  Seal: 'Seal',
  Split: 'Split',
  ShipmentByBarge: 'Shipment by barge',
  ShipmentByOther: 'Shipment by other',
  ShipmentByRailcar: 'Shipment by railcar',
  ShipmentByTruck: 'Shipment by truck',
  ShipmentByVessel: 'Shipment by vessel',
  Stuff: 'Stuffing',
  StuffForTransfer: 'Stuff for transfer',
  Transfer: 'Transfer',
  TransferredFromTC1: 'Transferred from TC1',
  Transform: 'Transform',
  Unseal: 'Unseal',
  Unstuff: 'Unstuffing',
  UnstuffForTransfer: 'Unstuff for transfer',
};

export default itemMovementType;
